import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

import { Icon } from '../iconTypes';

const IconCollapse = ({ className = '', color = '#979797', height = 13, title, width = 13 }: Icon) => (
    <AccessibleSVG
        className={`icon-collapse ${className}`}
        height={height}
        title={title}
        viewBox="0 0 13 13"
        width={width}
    >
        <path
            className="fill-color"
            d="M8 6h4a1 1 0 0 0 0-2H9V1a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1zM1 9h3v3a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1H1a1 1 0 0 0 0 2z"
            fill={color}
        />
    </AccessibleSVG>
);

export default IconCollapse;
